<template>
    <component
        :is="version"
        class="header shadow"
        v-model="isMenuActive"
    ></component>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const getters = [
    'is_menuCollapsed',
];

export default {
    name: 'Header',
    data: () => ({
        isMenuActive: false,
    }),
    computed: {
        ...mapGetters(getters),
        version() {
            return 'WideHeader';
        },
    },
    components: {
        WideHeader: () => import('../components/header/WideHeader'),
    },
    watch: {
        $route() {
            this.isMenuActive = false;
        },
        isMenuActive(value) {
            if (value) document.body.style.overflow = 'hidden';
            else document.body.style.overflow = 'auto';
        },
    },
};
</script>

<style lang="scss" scoped>
    .header {
        width: 100%;
        background-color: #fff;

        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        z-index: 24000;
        top: 0;
    }
</style>
